module.exports = __webpack_public_path__ + "static/img/img-aboutus-01.e1a6a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-aboutus-01.png
// module id = Ktwl
// module chunks = 1